<template>
  <div style="background: url('/img/assets/BACKGROUND.jpg')">
    <MainForm
      :name="FORM_NAMES.technicalErrorDigital"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPageDigital"
      :ui-form="uiForm"
      ui-title=""
    >
   
    </MainForm>
  </div>
</template>

<script>
// Models
var flag = true;
let newProduct = "";
const GlobalVariables = {
  isThankYouScreen: false
};
import Vue from "vue";
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
// Utils
import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import store from "@/store";
import FIELD_NAMES from "@/forms/constants/field-names";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
import FieldsetModel from "@/lib/components/models/fieldset";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import Appointment from "@/forms/components/shared/fieldsets/appointment-date";
import uploadService from "@/forms/api/services/upload";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import {
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  MOBILE_NUMBER_LENGTH_GLOBAL,
  DIGIT_CHARS,
  NAMES_CHARS,
  MAPPED_PHONE_CODE,
  ADDRESS_CHARS
} from "@/forms/constants/onboarding-logic";
import {
  InputText,
  InputSlide,
  Dropdown,
  PlainText,
  Choice,
  Feedback,
  InputTime,
  Suggest
} from "@dunia/ui";
export default {
  name: "TechnicalError",

  mixins: [FormComponentMixin],

  components: {
    // Components
    MainForm,
    StepModel,
    Appointment,
    InputText,
    Dropdown,
    Suggest,
    FieldsetModel,
    UiWrapper,
    Choice,
    FieldsetMobilePhone,
    FieldsetFullName
  },
props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.appointmentSetAddress
    },
    title: {
      type: String,
      default: "Please enter your office address below"
    },
     titleHome: {
      type: String,
      default: "Please enter your UAE residential address below",
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number"
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length"
        }
      ]
    },
    validationsGlobal: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },

        {
          errorMessage: "Your phone must be between 9-11 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH_GLOBAL),
          name: "check-is-mobile-length"
        }
      ]
    },
    addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars"
        }
      ]
    },
    pinCodeValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Field contains invalid characters.",
          condition: patternCondition(DIGIT_CHARS),
          name: "pincode-chars"
        }
      ]
    },
    prefix: {
      type: String,
      default: "+971"
    },
    maxlength: {
      type: Number,
      default: 9
    },
    minlength: {
      type: Number,
      default: 9
    },
    minlengthGlobal: {
      type: Number,
      default: 11
    }
  },
  methods: {
    ...conditions,
   
  },

  mounted() {
       let product = this.$store.state.productType;

    // if (product === "Personal_Loan") {
    //   newProduct = "Loan";
    // } else if (product === "Credit Card") {
    //   newProduct = "Credit Card";
    // }
    // let status = this.$store.state.appianIncomeInfo;
    // let cifNumber;
    // if (this.$store.state.cifnumber) {
    //   cifNumber = this.$store.state.cifnumber;
    // } else {
    //   cifNumber = "";
    // }

    let message;
   
   
      message = `Thanks ${this.userName}, thank you for your application. Our team will contact you shortly to update you on your application.`;
     finishCallback: {
       
      this.showEndPage({
        subtitle: "",
        actionNameEndForm: "Back To Home"
      });
    }
  }
};
</script>
